// components/AvatarEditorComponent.tsx
import React, { forwardRef } from "react";
import AvatarEditor from "react-avatar-editor";
import { Slider, Typography, Box, Button } from "@mui/material";

type Props = {
  image: File;
  scale: number;
  onScaleChange: (value: number) => void;
  onSubmit: () => void;
};

const AvatarEditorComponent = forwardRef<AvatarEditor, Props>(
  ({ image, scale, onScaleChange, onSubmit }, ref) => {
    const [editorSize, setEditorSize] = React.useState(512);
    const containerRef = React.useRef<HTMLDivElement>(null);

    React.useEffect(() => {
      const updateSize = () => {
        if (containerRef.current) {
          // コンテナの実際の幅を取得（パディングを含む）
          const containerWidth = containerRef.current.clientWidth;
          // エディターサイズを計算（最大512px）
          const newSize = Math.min(512, containerWidth - 40);
          setEditorSize(newSize);
        }
      };

      updateSize();
      window.addEventListener('resize', updateSize);
      return () => window.removeEventListener('resize', updateSize);
    }, []);

    return (
      <Box
        ref={containerRef}
        sx={{
          display: "flex",
          flexDirection: "column",
          gap: 2,
          maxWidth: 512, // エディターの最大サイズに合わせる
          width: '100%',
          mx: 'auto',
          px: { xs: 2, sm: 3 },
          boxSizing: 'border-box', // パディングを幅に含める
        }}
      >
        <Box
          sx={{
            width: '100%',
            display: 'flex',
            justifyContent: 'center',
            '& canvas': {
              maxWidth: '100%',
              height: 'auto !important',
            }
          }}
        >
          <AvatarEditor
            ref={ref}
            image={image}
            width={editorSize}
            height={editorSize}
            border={Math.floor(editorSize * 0.05)}
            scale={scale}
            borderRadius={0}
            color={[255, 255, 255, 0.6]}
          />
        </Box>
        <Box sx={{ width: '100%', px: 1 }}>
          <Slider
            value={scale}
            onChange={(e, newValue) => onScaleChange(newValue as number)}
            min={1.0}
            max={8.0}
            step={0.1}
            aria-labelledby="scale-slider"
          />
        </Box>
        <Box sx={{ width: '100%', display: 'flex', justifyContent: 'center' }}>
          <Button variant="contained" onClick={onSubmit}>
            登録する
          </Button>
        </Box>
      </Box>
    );
  }
);

export default AvatarEditorComponent;
